import { useState } from "react";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { Alert, Box, Button, TextField, Typography } from "@mui/material";
import { Card, Section } from "../components/ui";
import { COGNITO_CONFIGURED, confirmSignUp, resendConfirmationCode, signUp } from "../services/cognitoAuthService";
import { tokens } from "../theme";

export default function Signup() {
  const navigate = useNavigate();
  const [step, setStep] = useState("form");
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [info, setInfo] = useState("");
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const run = async (fn) => {
    setError(""); setInfo(""); setBusy(true);
    try { await fn(); } catch (err) { setError(err?.message || "Something went wrong."); } finally { setBusy(false); }
  };

  const submit = (e) => { e.preventDefault(); run(async () => { await signUp(form.email.trim(), form.password, form.name.trim()); setStep("confirm"); }); };
  const confirm = (e) => { e.preventDefault(); run(async () => { await confirmSignUp(form.email.trim(), code.trim()); navigate("/login"); }); };
  const resend = () => run(async () => { await resendConfirmationCode(form.email.trim()); setInfo("A new code was sent."); });

  return (
    <Section tone="sage" narrow sx={{ minHeight: "70vh" }}>
      <Card sx={{ maxWidth: 460, mx: "auto" }}>
        <Typography variant="h3" sx={{ fontSize: 32 }}>{step === "form" ? "Create your account" : "Check your email"}</Typography>
        {!COGNITO_CONFIGURED && <Alert severity="info" sx={{ mt: 2 }}>Sign-up is not configured in this preview.</Alert>}
        {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
        {info && <Alert severity="success" sx={{ mt: 2 }}>{info}</Alert>}
        {step === "form" ? (
          <Box component="form" onSubmit={submit} sx={{ display: "grid", gap: 2, mt: 3 }}>
            <TextField label="Full name" value={form.name} onChange={set("name")} required autoComplete="name" />
            <TextField label="Email" type="email" value={form.email} onChange={set("email")} required autoComplete="email" />
            <TextField label="Password" type="password" value={form.password} onChange={set("password")} required autoComplete="new-password" helperText="At least 8 characters" />
            <Button type="submit" variant="contained" size="large" disabled={busy || !COGNITO_CONFIGURED}>{busy ? "Creating..." : "Create account"}</Button>
          </Box>
        ) : (
          <Box component="form" onSubmit={confirm} sx={{ display: "grid", gap: 2, mt: 3 }}>
            <Typography sx={{ color: tokens.muted }}>We sent a code to {form.email}.</Typography>
            <TextField label="Verification code" value={code} onChange={(e) => setCode(e.target.value)} required />
            <Button type="submit" variant="contained" size="large" disabled={busy}>Verify</Button>
            <Button onClick={resend} disabled={busy}>Send a new code</Button>
          </Box>
        )}
        <Typography sx={{ mt: 3, fontSize: 14, color: tokens.muted }}>Already a member? <RouterLink to="/login">Log in</RouterLink></Typography>
      </Card>
    </Section>
  );
}
